import { render, staticRenderFns } from "./gameType.vue?vue&type=template&id=d0885428&"
import script from "./gameType.vue?vue&type=script&lang=js&"
export * from "./gameType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0885428')) {
      api.createRecord('d0885428', component.options)
    } else {
      api.reload('d0885428', component.options)
    }
    module.hot.accept("./gameType.vue?vue&type=template&id=d0885428&", function () {
      api.rerender('d0885428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/gameType.vue"
export default component.exports